export const getDataToConvert = (isSpice, isLessThanOne) => {
  const fractionConverter = [
    {
      key: '02',
      value: isLessThanOne && isSpice ? 'Prise' : String.fromCharCode(188)
    },
    {
      key: '03',
      value: isLessThanOne && isSpice ? 'Prise' : String.fromCharCode(188)
    },
    {
      key: '05',
      value: isLessThanOne && isSpice ? 'Prise' : String.fromCharCode(188)
    },
    {
      key: '06',
      value: isLessThanOne && isSpice ? 'Prise' : String.fromCharCode(188)
    },
    {
      key: '07',
      value: isLessThanOne && isSpice ? 'Prise' : String.fromCharCode(188)
    },
    {
      key: '08',
      value: isLessThanOne && isSpice ? 'Prise' : String.fromCharCode(188)
    },
    {
      key: '09',
      value: isLessThanOne && isSpice ? 'Prise' : String.fromCharCode(188)
    },
    {
      key: '1',
      value: isLessThanOne && isSpice ? 'Prise' : String.fromCharCode(188)
    },
    {
      key: '125',
      value: isLessThanOne && isSpice ? 'Prise' : String.fromCharCode(188)
    },
    {
      key: '12',
      value: isLessThanOne && isSpice ? 'Prise' : String.fromCharCode(188)
    },
    {
      key: '13',
      value: isLessThanOne && isSpice ? 'Prise' : String.fromCharCode(188)
    },
    {
      key: '14',
      value: isLessThanOne && isSpice ? 'Prise' : String.fromCharCode(188)
    },
    {
      key: '15',
      value: isLessThanOne && isSpice ? 'Prise' : String.fromCharCode(188)
    },
    {
      key: '16',
      value: isLessThanOne && isSpice ? 'Prise' : String.fromCharCode(188)
    },
    {
      key: '17',
      value: isLessThanOne && isSpice ? 'Prise' : String.fromCharCode(188)
    },
    {
      key: '19',
      value: isLessThanOne && isSpice ? 'Prise' : String.fromCharCode(188)
    },
    { key: '2', value: String.fromCharCode(188) },
    { key: '21', value: String.fromCharCode(188) },
    { key: '22', value: String.fromCharCode(188) },
    { key: '23', value: String.fromCharCode(188) },
    { key: '25', value: String.fromCharCode(188) },
    { key: '26', value: String.fromCharCode(188) },
    { key: '28', value: String.fromCharCode(188) },
    { key: '29', value: String.fromCharCode(188) },
    { key: '3', value: String.fromCharCode(188) },
    { key: '31', value: String.fromCharCode(8531) },
    { key: '33', value: String.fromCharCode(8531) },
    { key: '35', value: String.fromCharCode(8531) },
    { key: '36', value: String.fromCharCode(8531) },
    { key: '38', value: String.fromCharCode(8531) },
    { key: '39', value: String.fromCharCode(8531) },
    { key: '4', value: String.fromCharCode(8531) },
    { key: '42', value: String.fromCharCode(189) },
    { key: '43', value: String.fromCharCode(189) },
    { key: '44', value: String.fromCharCode(189) },
    { key: '45', value: String.fromCharCode(189) },
    { key: '46', value: String.fromCharCode(189) },
    { key: '48', value: String.fromCharCode(189) },
    { key: '5', value: String.fromCharCode(189) },
    { key: '53', value: String.fromCharCode(189) },
    { key: '55', value: String.fromCharCode(189) },
    { key: '56', value: String.fromCharCode(189) },
    { key: '58', value: String.fromCharCode(189) },
    { key: '59', value: String.fromCharCode(189) },
    { key: '6', value: String.fromCharCode(8532) },
    { key: '63', value: String.fromCharCode(8532) },
    { key: '65', value: String.fromCharCode(8532) },
    { key: '66', value: String.fromCharCode(8532) },
    { key: '67', value: String.fromCharCode(8532) },
    { key: '68', value: String.fromCharCode(8532) },
    { key: '69', value: String.fromCharCode(8532) },
    { key: '7', value: String.fromCharCode(8532) },
    { key: '71', value: String.fromCharCode(190) },
    { key: '73', value: String.fromCharCode(190) },
    { key: '75', value: String.fromCharCode(190) },
    { key: '76', value: String.fromCharCode(190) },
    { key: '78', value: String.fromCharCode(190) },
    { key: '79', value: String.fromCharCode(190) },
    { key: '8', value: String.fromCharCode(190) },
    { key: '81', value: String.fromCharCode(190) },
    { key: '83', value: String.fromCharCode(190) },
    { key: '85', value: String.fromCharCode(190) },
    { key: '86', value: String.fromCharCode(190) },
    { key: '88', value: String.fromCharCode(190) },
    { key: '89', value: String.fromCharCode(190) },
    { key: '9', value: String.fromCharCode(190) },
    { key: '92', value: String.fromCharCode(190) },
    { key: '93', value: String.fromCharCode(190) },
    { key: '94', value: String.fromCharCode(190) },
    { key: '95', value: String.fromCharCode(190) },
    { key: '96', value: String.fromCharCode(190) },
    { key: '98', value: String.fromCharCode(190) },
    { key: '99', value: String.fromCharCode(190) }
  ]

  return fractionConverter
}
